document.addEventListener("DOMContentLoaded", function () {
  // Select the button with the "mobile-nav-trigger" class
  var hamburgerBtn = document.querySelector(".mobile-nav-trigger");
  var targetElement = document.getElementById("MobileNav");
  var toggleClass = "is-active";
  var toggleClass2 = "transitioning";

  // Ensure the button exists before adding the event listener
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener("click", function () {
      console.log("Button clicked");
      // Toggle the class on the target element
      if (targetElement) {
        hamburgerBtn.classList.toggle(toggleClass);
        targetElement.classList.toggle(toggleClass);
        targetElement.classList.toggle(toggleClass2);
      } else {
        console.error("Target element not found");
      }
    });
  } else {
    console.error("Hamburger button not found");
  }
});
document.querySelectorAll(".js-toggle-submenu").forEach((button) => {
  button.addEventListener("click", function () {
    // Retrieve the target data attribute and current level from the clicked button
    const target = this.getAttribute("data-target");
    const currentLevel = this.getAttribute("data-level") ?? 1;

    // Find the corresponding <ul> element with a matching data-parent attribute
    const ulElement = document.querySelector(
      `.slide-nav__dropdown[data-parent="${target}"]`
    );

    // Find the wrapper <div> for the current level
    const divElement = document.querySelector(
      `.slide-nav__wrapper.overlay[data-level="${currentLevel}"]`
    );

    // If there is already an active <ul> for the same level, deactivate it
    const activeUl = document.querySelector(
      `.slide-nav__dropdown[data-level="${currentLevel}"].is-active`
    );
    if (activeUl && activeUl !== ulElement) {
      activeUl.classList.remove("is-active"); // Remove 'is-active' class from the previously active <ul>
    }

    if (divElement) {
      divElement.style.height = ""; // Reset the height of the <div> for the current level
    }

    if (ulElement) {
      // Add the 'is-active' class to the <ul> element
      ulElement.classList.add("is-active");

      // Set the height of the <div> based on the <ul>'s height
      const ulHeight = ulElement.offsetHeight;
      divElement.style.height = `${ulHeight}px`;
    }
  });
});

// Handle clicks for nested levels dynamically
document.querySelectorAll(".js-toggle-submenu").forEach((button) => {
  button.addEventListener("click", function () {
    const parentUl = this.closest("ul");
    const target = this.getAttribute("data-target");
    const parentUltarget = parentUl.getAttribute("data-parent");
    const currentLevel = parentUl.getAttribute("data-level");
    const level = this.getAttribute("data-level");
    const targetNumber = target && target.match(/\d+/);
    const parentTargetNumber = parentUltarget && parentUltarget.match(/\d+/);
    const activeUl = document.querySelector(
      `.slide-nav__dropdown[data-level="${currentLevel}"].is-active`
    );
    if (targetNumber == null && currentLevel == 2) {
      activeUl.classList.remove("is-active");
    }
    if (
      level == null &&
      target != parentUltarget &&
      targetNumber < parentTargetNumber
    ) {
      if (currentLevel > 2) {
        const perentlevel = currentLevel - 1;
        const parentUlParent = document.querySelector(
          `.slide-nav__dropdown[data-level="${perentlevel}"].is-active`
        );
        activeUl.classList.remove("is-active");
        parentUlParent.classList.add("is-active");
      }
    }
  });
});
